import { render, staticRenderFns } from "./AttachXMLModal.vue?vue&type=template&id=31392db2&"
import script from "./AttachXMLModal.vue?vue&type=script&lang=js&"
export * from "./AttachXMLModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports